// I/O client pour la connexion Google Calendar (EPIC E PR3a).
import { supabase } from '../../lib/supabaseClient';

export interface GoogleConnection {
  google_email: string;
  status: 'active' | 'revoked' | 'error';
  connected_at: string;
  last_sync_at: string | null;
  last_error: string | null;
  scopes: string[];
}

/** Connexion de l'avocat courant (RLS : ne voit que la sienne). null si aucune. */
export async function getMyGoogleConnection(
  collaboratorId: string,
): Promise<GoogleConnection | null> {
  const { data, error } = await supabase
    .from('google_connections')
    .select('google_email, status, connected_at, last_sync_at, last_error, scopes')
    .eq('collaborator_id', collaboratorId)
    .maybeSingle();
  if (error) throw new Error(`Failed to load Google connection: ${error.message}`);
  return (data as GoogleConnection | null) ?? null;
}

/** Démarre l'OAuth (tous les scopes par défaut) : récupère l'URL Google et redirige. */
export async function startGoogleConnect(): Promise<void> {
  const { data, error } = await supabase.functions.invoke('google-oauth-start', {
    method: 'POST',
  });
  if (error) throw new Error(`OAuth start failed: ${error.message}`);
  const url = (data as { url?: string })?.url;
  if (!url) throw new Error('OAuth start: no URL returned');
  window.location.href = url;
}

/**
 * Démarre l'OAuth pour un sous-ensemble de services (ex. ['calendar'] ou ['gmail']).
 * L'Edge Function google-oauth-start accepte `?services=calendar,gmail`.
 */
export async function startGoogleConnectServices(services: string[]): Promise<void> {
  const { data, error } = await supabase.functions.invoke(
    `google-oauth-start?services=${services.join(',')}`,
    { method: 'POST' },
  );
  if (error) throw new Error(`OAuth start failed: ${error.message}`);
  const url = (data as { url?: string })?.url;
  if (!url) throw new Error('OAuth start: no URL returned');
  window.location.href = url;
}

/** Déconnecte tout (revoke + purge). */
export async function disconnectGoogle(): Promise<void> {
  const { error } = await supabase.functions.invoke('google-oauth-disconnect', {
    method: 'POST',
  });
  if (error) throw new Error(`Disconnect failed: ${error.message}`);
}

/**
 * Déconnecte un service spécifique (calendar ou gmail).
 * L'Edge Function google-oauth-disconnect accepte `?service=calendar`.
 */
export async function disconnectGoogleService(service: string): Promise<void> {
  const { error } = await supabase.functions.invoke(
    `google-oauth-disconnect?service=${service}`,
    { method: 'POST' },
  );
  if (error) throw new Error(`Disconnect ${service} failed: ${error.message}`);
}
